"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getConfig", {
    enumerable: true,
    get: function() {
        return getConfig;
    }
});
const _os = /*#__PURE__*/ _interop_require_default(require("os"));
const _readConfigFile = require("./readConfigFile.js");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getConfig(cwd) {
    const config = await (0, _readConfigFile.readConfigFile)(cwd) || {};
    const availableParallelism = "availableParallelism" in _os.default ? _os.default["availableParallelism"]() : _os.default.cpus().length - 1;
    return {
        cacheOptions: config?.cacheOptions ?? {},
        ignore: config?.ignore ?? [],
        npmClient: config?.npmClient ?? "npm",
        pipeline: config?.pipeline ?? {},
        priorities: config?.priorities ?? [],
        repoWideChanges: config?.repoWideChanges ?? [
            "lage.config.js",
            "package-lock.json",
            "yarn.lock",
            "pnpm-lock.yaml",
            "lerna.json",
            "rush.json"
        ],
        loggerOptions: config?.loggerOptions ?? {},
        runners: config?.runners ?? {},
        workerIdleMemoryLimit: config?.workerIdleMemoryLimit ?? _os.default.totalmem(),
        concurrency: config?.concurrency ?? availableParallelism,
        allowNoTargetRuns: config?.allowNoTargetRuns ?? false,
        enableTargetConfigMerging: config?.enableTargetConfigMerging ?? false,
        reporters: config?.reporters ?? {}
    };
}
